<template>
  <div class="hospital-layout-header">
    <header-top></header-top>
    <div class="hospital-layout-header-menu clearfix">
      <div @click="goHome" class="left">Precision Diagnosis</div>
      <div class="center">
        <ul>
          <li
            :class="{ active: currentMenu.name == item.name }"
            :key="item.name"
            v-for="item in menus"
          >
            <a @click="checkMenus(item)">{{ item.name }}</a>
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="wei_header_bell" @click="bell()"></div>
        <div class="wei_header_uec" @click="blankUec()"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import HeaderTop from "@/components/wordbench/header";

const logoUrl = require("" + process.env.VUE_APP_HEADER_LOGO + "");
export default {
  components: { HeaderTop },
  computed: {
    ...mapState({
      user: (state) => state.account.user,
      avatar() {
        return `static/avatar/${this.user.avatar}`;
      },
    }),
  },
  data() {
    return {
      envLogo: logoUrl,
      currentMenu: {},
      defaultMenus: {
        path: "/home",
        name: "首页",
      },
      menus: [],
      commonList: ["/profile", "404", "/note"],
      allMenus: [
        {
          path: "/home",
          name: "首页",
        },
        {
          path: "/statistics",
          name: "统计分析",
          icon: "/icon/tongjifenxi.png",
        },
        {
          path: "/diagnosis",
          name: "就诊流程",
          icon: "/icon/liucheng-3.png",
        },
        {
          path: "/job",
          name: "作业管理",
          icon: "/icon/zuoye.png",
        },
        {
          path: "/report",
          name: "报告管理",
          icon: "/icon/xingzhuang.png",
        },
        {
          path: "/sufferer",
          name: "患者管理",
          icon: "/icon/huanzhe2.png",
        },
        {
          path: "/sample",
          name: "样本管理",
          icon: "/icon/yangbenguanli.png",
        },
        {
          path: "/turn/user",
          name: "总控设置",
          icon: "/icon/shezhi-4.png",
        },
      ],
    };
  },
  watch: {
    $route(val) {
      if (val.name == "首页") {
        this.menus = [];
      } else {
        this.initMenus();
        this.menus.forEach((item) => {
          let me = this.commonList.find((d) => d == this.$route.path);
          if (!me) {
            if (item.path == this.$route.path) {
              this.currentMenu = item;
            } else if (this.$route.path == "/sample/detail") {
              this.currentMenu = {
                path: "/sample",
                name: "样本管理",
                icon: "/icon/yangbenguanli.png",
              };
            }
          } else {
            this.currentMenu = {};
          }
        });
      }
    },
  },
  created() {
    this.initMenus();
    if (this.$route.name == "首页") {
      this.menus = [];
    } else {
      this.menus.forEach((item) => {
        let me = this.commonList.find((d) => d == this.$route.path);
        if (!me) {
          if (item.path == this.$route.path) {
            this.currentMenu = item;
          }
        } else {
          this.currentMenu = {};
        }
      });
    }
  },
  methods: {
    bell() {
      this.$router.push("/note");
    },
    blankUec() {
      const openUrl = process.env.VUE_APP_BLANK_UEC_URL;
      window.open(openUrl);
    },
    initMenus() {
      this.menus = [];
      this.menus.push(this.defaultMenus);
      const userMenus = this.$db.get("userMenusAllMenus");
      if (userMenus.length) {
        this.allMenus.forEach((item) => {
          let isHave = userMenus.find((d) => d.name == item.name);
          if (isHave) {
            if (item.name == "总控设置") {
              item.path =
                isHave.children.length > 0 ? isHave.children[0].path : "/404";
            }
            this.menus.push(item);
          }
        });
      }
    },
    checkMenus(item) {
      if (item.path != this.$route.path) {
        this.$store.state.account.isActive = true;
        this.currentMenu = item;
        this.$router.push(item.path);
      }
    },
    goHome() {
      this.$router.push("/home");
    },
    logout() {
      NProgress.start();
      this.$get(`logout/${this.user.id}`).then(
        () => {
          return new Promise((resolve, reject) => {
            NProgress.done();
            this.$db.clear();
            location.reload();
          });
        },
        () => {
          NProgress.done();
          this.$message.error("退出系统失败");
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.hospital-layout-header {
  min-width: 1200px;
  .right {
    text-align: right;
  }
  /deep/ .ant-avatar {
    overflow: initial;
    vertical-align: inherit;
  }
  .center {
    float: left;
    white-space: nowrap;
    margin-top: 13px;
    li + li {
      margin-left: 20px;
    }
    ul {
      margin: 0;
    }
    ul li {
      list-style: none;
      padding: 0px;
      height: auto;
      display: inline-block;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      cursor: pointer;
      a {
        color: rgba(51, 51, 51, 1);
      }
      &.active {
        padding-bottom: 8px;
        color: #4c84ff;
        cursor: default;
        border-bottom: 2px solid #4c84ff;
        a {
          color: #4c84ff;
        }
      }
    }
  }
}

@media only screen and (min-width: 0) {
  .hospital-layout-header {
    position: fixed;
    width: 100%;
    min-width: 1200px;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 20;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.26);
    .hospital-layout-header-menu {
      height: 48px;
    }
    .left {
      float: left;
      width: 420px;
      float: left;
      cursor: pointer;
      padding-left: 20px;
      font-size: 14px;
      line-height: 47px;
    }
    .right {
      float: right;
      height: 100%;
      width: 320px;
      .wei_header_user {
        display: inline-block;
        padding-right: 30px;
        vertical-align: top;
        height: 60px;
      }
      .wei_header_bell {
        cursor: pointer;
        width: 48px;
        height: 48px;
        display: inline-block;
        border-left: 1px solid #f0f2f5;
        background: url("../../assets/image/imgHome/bell_1.png");
        background-size: contain;
      }
      .wei_header_uec {
        cursor: pointer;
        width: 48px;
        height: 48px;
        display: inline-block;
        border-left: 1px solid #f0f2f5;
        border-right: 1px solid #f0f2f5;
        background: #000 url("../../assets/image/imgHome/uec-logo.jpg") 0 center
          no-repeat;
        background-size: cover;
        -moz-transition: all 0.15s ease-in;
        -webkit-transition: all 0.15s ease-in;
        -o-transition: all 0.15s ease-in;
        transition: all 0.15s ease-in;
      }
      .wei_header_uec:hover {
        background-position: -48px center;
        -moz-transition: all 0.15s ease-in;
        -webkit-transition: all 0.15s ease-in;
        -o-transition: all 0.15s ease-in;
        transition: all 0.15s ease-in;
      }
      .avatar {
        height: 49px;
        width: 49px;
      }
      .wei_dropdown {
        position: relative;
        left: 10px;
        color: #a7adb4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        width: 90px;
        line-height: 60px;
      }
      .wei_dropdown i {
        position: relative;
        top: 2px;
      }
    }
  }
}

@media only screen and (min-width: 1580px) {
  .hospital-layout-header {
    position: fixed;
    width: 100%;
    min-width: 1200px;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 20;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    .center {
      float: left;
      white-space: nowrap;
      margin-top: 14px;
      li + li {
        margin-left: 35px;
      }
      ul {
        margin: 0;
      }
      ul li {
        list-style: none;
        padding: 0px;
        height: auto;
        display: inline-block;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
        a {
          color: rgba(51, 51, 51, 1);
        }
        &.active {
          padding-bottom: 8px;
          color: #4c84ff;
          cursor: default;
          border-bottom: 2px solid #4c84ff;
          a {
            color: #4c84ff;
          }
        }
      }
    }
    .left {
      float: left;
      height: 100%;
      width: 560px;
      height: 48px;
      float: left;
      cursor: pointer;
    }
    .right {
      float: right;
      height: 100%;
      width: 360px;
      .wei_header_user {
        height: 80px;
      }
      .wei_header_bell {
        width: 48px;
        height: 48px;
        display: inline-block;
        border-left: 1px solid #f0f2f5;
        // background: url("../../assets/image/imgHome/bell_1.png");
      }
      .wei_header_uec {
        cursor: pointer;
        width: 48px;
        height: 48px;
        display: inline-block;
        border-left: 1px solid #f0f2f5;
        border-right: 1px solid #f0f2f5;
        background: #000 url("../../assets/image/imgHome/uec-logo.jpg") 0 center
          no-repeat;
        background-size: cover;
        -moz-transition: all 0.15s ease-in;
        -webkit-transition: all 0.15s ease-in;
        -o-transition: all 0.15s ease-in;
        transition: all 0.15s ease-in;
      }
      .wei_header_uec:hover {
        background-position: -48px center;
        -moz-transition: all 0.15s ease-in;
        -webkit-transition: all 0.15s ease-in;
        -o-transition: all 0.15s ease-in;
        transition: all 0.15s ease-in;
      }
      .avatar {
        height: 61px;
        width: 61px;
      }
      .wei_dropdown {
        position: relative;
        left: 10px;
        color: #a7adb4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        width: 90px;
        line-height: 60px;
      }
      .wei_dropdown i {
        position: relative;
        top: 2px;
      }
    }
  }
}
</style>
